import React, { useContext, useMemo } from 'react';
import _ from 'underscore';

export const EditorStatusContext = React.createContext([{}, _.noop]);

export const PreviewMode = {
  Desktop: 'Desktop',
  Mobile: 'Mobile',
};

export const EditorView = {
  Components: 'Components',
  Settings: 'Settings',
  Style: 'Style/Brand',
};

export const useEditorStatusContext = () => {
  const contextValue = useContext(EditorStatusContext);
  return contextValue;
};

export const useIsComponentSelected = (type) => {
  const context = useContext(EditorStatusContext);

  const isSelected = useMemo(
    () => {
      if (!context) {
        return false;
      }
      const [editorStatus] = context;
      return editorStatus.editingComponentType === type;
    },
    [context, type]
  );

  return isSelected;
};

